module.exports = __webpack_public_path__ + "static/media/client-area-user-preferences.d78dd2ff.svg";